import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { Eye, EyeOff } from "lucide-react";
import { setToken } from "../../redux/actions/action";
import { postLogin, VERSION_WEB } from "../../api/ApiService";
import logo from "../../assets/imagenes/splash.png";



function LoginPage() {
    const [userName, setUserName] = useState("");
    const [password, setPassword] = useState("");
    const [open, setOpen] = useState(false);
    const [severity, setSeverity] = useState("");
    const [mensaje, setMensaje] = useState("");
    const [cargando, setCargando] = useState(false);
    const [showPassword, setShowPassword] = useState(false);

    const dispatch = useDispatch();
    const history = useNavigate();

    const handleClose = () => {
        setOpen(false);
    };

    const handleChangeUser = (e) => {
        setUserName(e.target.value);
    };

    const handleChangePas = (e) => {
        setPassword(e.target.value);
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        if (userName.trim() === "" || password.trim() === "") {
            setOpen(true);
            setSeverity("warning");
            setMensaje("Ingrese usuario y contraseña");
            return;
        }

        const body = {
            email: userName,
            password: password,
        };

        setCargando(true);
        handleApiLogin(body);
    };

    const handleApiLogin = (body) => {
        postLogin(body)
            .then((response) => {
                setCargando(false);
                dispatch(setToken(response));
                localStorage.setItem("dataUser", JSON.stringify(response));
                // history("/app/admin/eventos", { replace: true });
                history("/app/admin", { replace: true });
            })
            .catch(() => {
                setCargando(false);
                setMensaje("Usuario o contraseña incorrecta");
                setSeverity("error");
                setOpen(true);
            });
    };

    const eventEnter = (e) => {
        if (e.keyCode === 13 && password.trim() !== "" && userName.trim() !== "") {
            handleSubmit(e);
        }
    };

    const alertStyles = {
        success: "border-emerald-200 bg-emerald-50 text-emerald-700",
        error: "border-red-200 bg-red-50 text-red-700",
        warning: "border-amber-200 bg-amber-50 text-amber-700",
    };

    return (
        <div className="flex min-h-screen items-center justify-center bg-gray-100 p-4">
            <div className="w-full max-w-sm">
                <div className="overflow-hidden rounded-2xl bg-white shadow-xl">
                    <div className="flex flex-col items-center px-8 pb-8 pt-10">
                        <img
                            src={logo}
                            alt="logo"
                            className="mb-6 h-24 w-24 object-contain"
                        />

                        <h1 className="mb-1 text-xl font-bold text-gray-800">
                            Iniciar sesión
                        </h1>
                        <p className="mb-7 text-sm text-gray-500">
                            Gestor de Paseo La Galería
                        </p>

                        <div className="w-full space-y-4">
                            <div>
                                <label className="mb-1.5 block text-sm font-semibold text-gray-700">
                                    Correo electrónico
                                </label>
                                <input
                                    type="email"
                                    id="username"
                                    value={userName}
                                    onChange={handleChangeUser}
                                    autoCapitalize="none"
                                    autoCorrect="off"
                                    autoComplete="email"
                                    autoFocus
                                    placeholder="correo@ejemplo.com"
                                    className="w-full rounded-lg border border-gray-200 bg-[#f1f5f9] px-3 py-2.5 text-sm text-gray-700 outline-none transition focus:border-blue-300 focus:ring-2 focus:ring-blue-200"
                                />
                            </div>

                            <div>
                                <label className="mb-1.5 block text-sm font-semibold text-gray-700">
                                    Contraseña
                                </label>
                                <div className="relative">
                                    <input
                                        type={showPassword ? "text" : "password"}
                                        id="password"
                                        value={password}
                                        onChange={handleChangePas}
                                        onKeyDown={eventEnter}
                                        autoCapitalize="off"
                                        autoCorrect="off"
                                        autoComplete="off"
                                        placeholder="••••••••"
                                        className="w-full rounded-lg border border-gray-200 bg-[#f1f5f9] px-3 py-2.5 pr-10 text-sm text-gray-700 outline-none transition focus:border-blue-300 focus:ring-2 focus:ring-blue-200"
                                    />
                                    <button
                                        type="button"
                                        aria-label="toggle password visibility"
                                        onClick={() => setShowPassword(!showPassword)}
                                        className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 transition-colors hover:text-gray-600"
                                    >
                                        {showPassword ? <EyeOff size={18} /> : <Eye size={18} />}
                                    </button>
                                </div>
                            </div>

                            <button
                                type="button"
                                onClick={handleSubmit}
                                disabled={cargando}
                                className="mt-2 w-full rounded-lg bg-[#104063] py-2.5 font-semibold text-white transition-colors hover:bg-[#0d3553] disabled:cursor-not-allowed disabled:opacity-70"
                            >
                                {cargando ? (
                                    <span className="flex items-center justify-center gap-2">
                                        <span className="h-4 w-4 animate-spin rounded-full border-2 border-white border-t-transparent" />
                                        Ingresando...
                                    </span>
                                ) : (
                                    "Iniciar sesión"
                                )}
                            </button>
                        </div>

                        <p className="mt-6 text-xs text-gray-400">
                            Versión: {VERSION_WEB}
                        </p>
                    </div>
                </div>
            </div>

            {open && (
                <div className="fixed right-4 top-4 z-[10000] max-w-sm">
                    <div
                        className={`rounded-xl border px-4 py-3 shadow-lg ${alertStyles[severity] || alertStyles.error
                            }`}
                    >
                        <div className="flex items-start justify-between gap-4">
                            <p className="text-sm font-medium">{mensaje}</p>
                            <button
                                type="button"
                                onClick={handleClose}
                                className="text-current opacity-70 transition-opacity hover:opacity-100"
                            >
                                ×
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}

export default LoginPage;